console.log('✅ listing-page-component.js loaded successfully!');

export function buildComponentBlogCardArticle(
  link,
  image1FileName,
  title,
  date,
  defaultArticleCategoryName
) {
  try {
    const html = `


                        <a href="${link}">
                            <div class="grid-blog-home-featured-middle-section-card">
                                <div class="grid-blog-home-featured-middle-section-image-wrapper">


                                        <img src="${image1FileName}" alt="${title}" width="462" height="300" loading="lazy" />

                                    </div>



                                <div class="grid-blog-home-featured-middle-section-card-info-wrapper">

                                    <span class="grid-blog-home-info-badge"> ${defaultArticleCategoryName}</span>
                                    <span class="grid-blog-home-info-date-dark">
                                       ${date} 
                                    </span>

                                    <h2 class="grid-blog-home-featured-middle-section-card-info-h2">
                                        ${title}
                                    </h2>


                                </div>

                            </div>
                        </a>




         
        `;

    return html;

    return html;
  } catch (err) {
    console.error('❌ Error building BlogCardArticle:', err);
    return '<div>Error loading BlogCardArticle</div>';
  }
}
